import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'vibo-ui/Button';

import { SOURCES_DATA } from './constants';

import { SourceProps } from './interfaces';

const Source: FC<SourceProps> = ({ onClick, disabled, source, tooltipText }) => {
  const { t } = useTranslation();

  const { icon, text } = SOURCES_DATA[source];

  return (
    <Button
      onClick={() => onClick()}
      disabled={disabled}
      tooltipProps={{
        overlay: tooltipText ?? t(text),
        type: 'black',
        placement: 'left',
        align: {
          offset: [-4, 0],
        },
      }}
      prefixIcon={icon}
      displayType="white"
      shape="round"
      size="xl"
    />
  );
};

export default Source;
